import React, { Component } from 'react';
import * as util from '../../../../utils/EnumMapping';
import MainTable from '../../../common/table/MainTable';
import NewTaxType from './NewTaxType';
import * as columns from './TaxTypeColumns';

class TaxType extends Component {

    enrich = (data) => {
        data.map((item) => {
            item.rowType = "TAX_TYPE";
            item.state = util.getSecondValue(util.activeStates, item.active);
            item.stateLabel = util.getLabel(util.activeStates, item.active);
            item.taxPaymentTypeLabel = util.getLabel(util.taxTypes, item.type)
            return item;
        })
        return data;
    }

    render() {
        return (
            <MainTable
                divClassName="taxtype"
                tableName="Adónemek"
                newObjectLabel="Új adónem hozzáadása"
                path='/api/taxtypes'
                enrich={this.enrich}
                columns={(refresh) => columns.columns(refresh)}
                dialogContent={(refresh, close) => <NewTaxType refresh={refresh} close={close} />} />
        );
    }
}

export default TaxType;